<div class="container-fluid min-vh-100 d-flex align-items-center justify-content-center py-5">
  <div class="row w-100 justify-content-center">
    <div class="col-12 col-sm-10 col-md-8 col-lg-6 col-xl-5">
      <div class="card reset-password-card shadow-lg border-0">
        <div class="card-body p-4 p-md-5">
          <!-- Header Section -->
          <div class="text-center mb-4">
            <div class="reset-password-icon mb-3">
              <i class="fa fa-lock fa-3x text-primary"></i>
            </div>
            <h2 class="card-title fw-bold mb-2">{{ 'RESET_PASSWORD.TITLE' | translate }}</h2>
            <p class="text-muted mb-0">{{ 'RESET_PASSWORD.SUBTITLE' | translate }}</p>
          </div>

          <form [formGroup]="resetForm" (ngSubmit)="resetPassword()" novalidate>
            <!-- Password Section -->
            <div class="row">
              <div class="col-md-6 mb-3">
                <label for="password" class="form-label">
                  <i class="fa fa-lock me-2 text-muted"></i>{{ 'RESET_PASSWORD.PASSWORD_LABEL' | translate }}
                </label>
                <div class="input-group">
                  <span class="input-group-text border-end-0 bg-light">
                    <i class="fa fa-lock text-muted"></i>
                  </span>
                  <input
                    formControlName="password"
                    type="password"
                    class="form-control border-start-0"
                    [class.is-invalid]="resetForm.get('password')?.errors && resetForm.get('password')?.touched"
                    id="password"
                    [placeholder]="'RESET_PASSWORD.PASSWORD_PLACEHOLDER' | translate"
                    autocomplete="new-password"
                  />
                  <div class="invalid-feedback" *ngIf="resetForm.get('password')?.touched && resetForm.get('password')?.hasError('required')">
                    <i class="fa fa-exclamation-circle me-1"></i>{{ 'RESET_PASSWORD.PASSWORD_REQUIRED' | translate }}
                  </div>
                  <div class="invalid-feedback" *ngIf="resetForm.get('password')?.touched && resetForm.get('password')?.hasError('minlength')">
                    <i class="fa fa-exclamation-circle me-1"></i>{{ 'RESET_PASSWORD.PASSWORD_MIN_LENGTH' | translate }}
                  </div>
                </div>
              </div>

              <div class="col-md-6 mb-3">
                <label for="confirmPassword" class="form-label">
                  <i class="fa fa-lock me-2 text-muted"></i>{{ 'RESET_PASSWORD.CONFIRM_PASSWORD_LABEL' | translate }}
                </label>
                <div class="input-group">
                  <span class="input-group-text border-end-0 bg-light">
                    <i class="fa fa-lock text-muted"></i>
                  </span>
                  <input
                    formControlName="confirmPassword"
                    type="password"
                    class="form-control border-start-0"
                    [class.is-invalid]="(resetForm.get('confirmPassword')?.errors && resetForm.get('confirmPassword')?.touched) || (resetForm.hasError('distinctPasswordsError') && resetForm.get('confirmPassword')?.touched)"
                    id="confirmPassword"
                    [placeholder]="'RESET_PASSWORD.CONFIRM_PASSWORD_PLACEHOLDER' | translate"
                    autocomplete="new-password"
                  />
                  <div class="invalid-feedback" *ngIf="resetForm.get('confirmPassword')?.touched && resetForm.get('confirmPassword')?.hasError('required')">
                    <i class="fa fa-exclamation-circle me-1"></i>{{ 'RESET_PASSWORD.CONFIRM_PASSWORD_REQUIRED' | translate }}
                  </div>
                  <div class="invalid-feedback" *ngIf="resetForm.get('confirmPassword')?.touched && resetForm.hasError('distinctPasswordsError')">
                    <i class="fa fa-exclamation-circle me-1"></i>{{ 'RESET_PASSWORD.PASSWORDS_MUST_MATCH' | translate }}
                  </div>
                </div>
              </div>
            </div>

            <!-- Submit Button -->
            <div class="d-grid mb-4">
              <button
                type="submit"
                class="btn btn-primary btn-lg"
                [disabled]="!resetForm.valid"
              >
                <i class="fa fa-check me-2"></i>{{ 'RESET_PASSWORD.RESET_BUTTON' | translate }}
              </button>
            </div>

            <!-- Additional Links -->
            <div class="text-center">
              <div class="row">
                <div class="col-12 col-md-6 mb-2 mb-md-0">
                  <a [routerLink]="['/login']" class="btn btn-outline-secondary btn-sm w-100">
                    <i class="fa fa-arrow-left me-2"></i>{{ 'RESET_PASSWORD.BACK_TO_LOGIN' | translate }}
                  </a>
                </div>
                <div class="col-12 col-md-6">
                  <a [routerLink]="['/contact-us']" class="btn btn-outline-info btn-sm w-100">
                    <i class="fa fa-question-circle me-2"></i>{{ 'RESET_PASSWORD.NEED_HELP' | translate }}
                  </a>
                </div>
              </div>
            </div>

          </form>
        </div>
      </div>
    </div>
  </div>
</div>
